import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { format, isValid } from 'date-fns';
import { tr } from 'date-fns/locale';
import { calculateDaysSince } from 'layouts/production/helpers/dateHelpers';
import MDButton from 'components/MDButton';

export function ProductionCreationDate({ productionID, date }) {
    // Handle null or undefined values
    if (!date) {
        return <span>-</span>;
    }

    const formattedDate = new Date(date);

    // Check if date is valid
    if (!isValid(formattedDate)) {
        return <span>-</span>;
    }

    // Calculate days since creation
    const daysSince = calculateDaysSince(formattedDate);

    // Format the display text based on days passed
    let displayText;
    let color = 'info';

    if (daysSince === 0) {
        displayText = 'Bugün';
    } else if (daysSince === 1) {
        displayText = 'Dün';
    } else if (daysSince < 7) {
        displayText = `${daysSince} gün önce`;
    } else if (daysSince < 30) {
        const weeks = Math.floor(daysSince / 7);
        displayText = `${weeks} hafta önce`;
    } else if (daysSince < 365) {
        const months = Math.floor(daysSince / 30);
        displayText = `${months} ay önce`;
    } else {
        const years = Math.floor(daysSince / 365);
        displayText = `${years} yıl önce`;
        color = 'warning';
    }

    // For hover tooltip, format as full date (DD MMMM YYYY)
    const tooltipDate = format(formattedDate, 'dd MMMM yyyy', { locale: tr });

    return (
        <MDButton
            variant="outlined"
            color={color}
            size="small"
            fullWidth
            component={Link}
            to={`../productions/${productionID}`}
            target="_blank"
            rel="noopener noreferrer"
            circular
            title={tooltipDate}
        >
            {displayText}
        </MDButton>
    );
}

export default memo(ProductionCreationDate);
